'use strict';

angular.module('core').controller('AccountLockedController', ['$scope', '$state', '$stateParams', 'Authentication', 'SubscriptionMain', 'Utilities',
	function($scope, $state, $stateParams, Authentication, SubscriptionMain, Utilities) {
		$scope.authentication = Authentication;

		// Get the data of the user which is blocked
		$scope.lockedUser = {
			_id: $scope.authentication.user._id,
			displayName: $scope.authentication.user.displayName
		};
		if ($stateParams.lockedUser) {
			try {
				$scope.lockedUser = JSON.parse(decodeURI($stateParams.lockedUser));
			} catch(err) {
				// There was something wrong with the user parameter so ignore it
			}
		} else {
			// If the user visits the page without the needed data and he is
			// not locked himself redirect him to app page
			if (!$scope.authentication.user.accountLocked) {
				$state.go('listMobileApps');
				return;
			}
		}


		/**
		 * Displays modal to let user upgrade subscription
		 */
		$scope.openUpgradeModal = function() {

			Utilities.upgradeSubscriptionModal(undefined, function(err, result) {
				if (err && err !== 'escape key press') {
					Utilities.showMessage(
						'Error!',
						'There was a problem updating your subscription. Please contact the support! Thanks!',
						'error'
					);
					return;
				}

				if (result === true) {
					// If user did upgrade the subscription refresh the
					// currently loaded data and display him a success message

					Utilities.showMessage(
						'Success!',
						'You got successfully upgraded to a higher plan!',
						'success'
					);

					// Update the internal data so that the new plan gets
					// displayed everywhere correctly
					SubscriptionMain.getUserPlan(true, function(err, currentSubscription) {
						// Redirect user to app pages
						$state.go('listMobileApps');
					});
				}
			});

		};

	}
]);
